import { render } from "./RightContent.vue?vue&type=template&id=c906d51a&scoped=true"
import script from "./RightContent.vue?vue&type=script&lang=js"
export * from "./RightContent.vue?vue&type=script&lang=js"

import "./RightContent.vue?vue&type=style&index=0&id=c906d51a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c906d51a"]])

export default __exports__